<template>
  <div class="historyList">
    <div class="history"
         v-show="show">
      <p>最近查看</p>
      <p>
        <van-icon name="delete"
                  size="20px"
                  @click="del" />
      </p>

    </div>
    <div class="hislist"
         v-show="show">
      <section v-for="(item, index) in historyData"
               :key="index"
               @click="gotoEmployees(item.EMPLID)">
        <div class="divimg">
          <img v-if="item.PHOTO != ''"
               :src="`data:image/png;base64,${item.PHOTO}`"
               alt="" />

          <div class="divnameone"
               v-else>{{ item.NAME | cutName }}</div>
        </div>

        <div class="divInfo">
          <p class="divname">{{ item.NAME }}</p>
          <p>{{ item.DEPT_DESCR }}</p>
        </div>

      </section>
    </div>

  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  props: ['historyData', 'show'],

  methods: {
    gotoEmployees(num) {
      this.$store.commit('changeNum', num)
      this.$router.push('/employees')
    },

    del() {
      localStorage.clear(history)
      Toast.success('删除成功')
      window.location.reload()
    },
  },
  filters: {
    cutName(val) {
      return val.slice(0, 1)
    },
  },
}
</script>


<style lang = "less" scoped>
.historyList {
  background: white;
  .history {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    p {
      font-weight: bold;
      font-size: 16px;
    }
  }
}
section {
  height: 55px;
  background: white;
  font-size: 13px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  div {
    margin: 9px;
    p {
      color: #8f8f8f;
    }
    .divname {
      color: black;
      font-size: 15px;
    }
  }
  .divimg {
    width: 36px;
    height: 36px;
    background: #55a0f8;
    box-sizing: border-box;
    border-radius: 50%;
    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      /* //overflow: hidden; */
    }
    text-align: center;
    line-height: 36px;
    font-size: 18px;

    color: white;
    .divnameone {
      margin-top: 0px;
    }
  }
  .divright {
    flex: 1;
    line-height: 55px;
    margin: 0 10px 0 0;
    color: #55a0f8;
    text-align: right;
  }
}
section:last-child {
  border-bottom: 1px solid #e5e5e5;
}
</style>